import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import classNames from "classnames";

import {
  getAuthorListAsyncForTypeahead,
  getSubscriptionListAsyncForTypeahead,
} from "editor/actions/metadata";
import { onChange, onChangeCheckbox } from "editor/actions/form";

import AccordionItem from "components/library/AccordionItem";
import AsyncDropdown from "components/library/AsyncDropdown";
import Typeahead from "components/library/Typeahead";
import TextInput from "components/library/TextInput";
import Label from "components/library/Label";
import Checkbox from "components/library/Checkbox";
import RevisionsList from "editor/components/RevisionsList";

import styles from "./NewsletterMetadata.css";
import {
  NEWSLETTER_AUTHOR_PLACEHOLDER,
  NEWSLETTER_EDITOR_PLACEHOLDER,
  NEWSLETTER_SELECT_PLACEHOLDER,
  NEWSLETTER_SUBJECT_PLACEHOLDER,
  NEWSLETTER_PREVIEW_PLACEHOLDER,
  NEWSLETTER_PUSH_NOTIFICATION_PLACEHOLDER,
} from "config/constants/editor";

class NewsletterMetadata extends React.Component {
  constructor(props) {
    super(props);
    this.idPrefix = Math.random()
      .toString(36)
      .substring(7);
  }

  getId(field) {
    return `${this.idPrefix}-${field}`;
  }

  render() {
    return (
      <div>
        <AccordionItem title="Info & Options" isOpen={true}>
          <div className={styles.field}>
            <Label htmlFor={this.getId("authors")}>Authors</Label>
            <Typeahead
              className="gtm-add-newsletter-author"
              inputId={this.getId("authors")}
              value={this.props.form.authors}
              onChange={this.props.onChange("authors")}
              loadOptions={this.props.getAuthorListAsyncForTypeahead}
              labelKey="display_name"
              valueKey="id"
              placeholder={NEWSLETTER_AUTHOR_PLACEHOLDER}
              disabled={this.props.status.isReadOnly}
              error={this.props.form.errors.authors}
            />
          </div>

          <div className={styles.field}>
            <Label htmlFor={this.getId("editors")}>Editors</Label>
            <Typeahead
              className="gtm-add-newsletter-editor"
              inputId={this.getId("editors")}
              value={this.props.form.editors}
              onChange={this.props.onChange("editors")}
              loadOptions={this.props.getAuthorListAsyncForTypeahead}
              labelKey="display_name"
              valueKey="id"
              placeholder={NEWSLETTER_EDITOR_PLACEHOLDER}
              disabled={this.props.status.isReadOnly}
            />
          </div>

          <div className={styles.field}>
            <Label htmlFor={this.getId("subscription")}>Newsletter</Label>
            <AsyncDropdown
              className="gtm-select-newsletter"
              inputId={this.getId("subscription")}
              value={this.props.form.subscription}
              onChange={this.props.onChange("subscription")}
              loadOptions={this.props.getSubscriptionListAsyncForTypeahead}
              labelKey="name"
              valueKey="id"
              placeholder={NEWSLETTER_SELECT_PLACEHOLDER}
              disabled={this.props.status.isReadOnly}
              error={this.props.form.errors.subscription}
            />
          </div>

          <div className={styles.field}>
            <Label htmlFor={this.getId("subject_line")}>Subject line</Label>
            <TextInput
              id={this.getId("subject_line")}
              className={classNames(
                styles.input,
                "gtm-newsletter-subject-line"
              )}
              placeholder={NEWSLETTER_SUBJECT_PLACEHOLDER}
              value={this.props.form.subject_line}
              onChange={this.props.onChange("subject_line")}
              disabled={this.props.status.isReadOnly}
              error={this.props.form.errors.subjectLine}
              dataCy={"subjectLine"}
            />
          </div>

          <div className={styles.field}>
            <Label htmlFor={this.getId("preview_text")}>Preview text</Label>
            <TextInput
              id={this.getId("preview_text")}
              className={classNames(
                styles.input,
                "gtm-newsletter-preview-text"
              )}
              placeholder={NEWSLETTER_PREVIEW_PLACEHOLDER}
              value={this.props.form.preview_text}
              onChange={this.props.onChange("preview_text")}
              disabled={this.props.status.isReadOnly}
            />
          </div>

          <div className={styles.field}>
            <Label htmlFor={this.getId("push_notification_text")}>
              Push notification text
            </Label>
            <TextInput
              id={this.getId("push_notification_text")}
              className={classNames(styles.input, "gtm-push-notification-text")}
              placeholder={NEWSLETTER_PUSH_NOTIFICATION_PLACEHOLDER}
              value={this.props.form.push_notification_text || ""}
              onChange={this.props.onChange("push_notification_text")}
              disabled={this.props.status.isReadOnly}
            />
          </div>

          <div className={styles.checkbox}>
            <div className={styles.field}>
              <Checkbox
                label="Needs visuals"
                isChecked={this.props.form.needs_visuals}
                isDisabled={this.props.status.isReadOnly}
                onChange={this.props.onChangeCheckbox("needs_visuals")}
              />
            </div>

            <div className={styles.field}>
              <Checkbox
                label="Publish to Apple News"
                isChecked={this.props.form.publish_to_apple_news}
                isDisabled={this.props.status.isReadOnly}
                onChange={this.props.onChangeCheckbox("publish_to_apple_news")}
              />
            </div>
          </div>
        </AccordionItem>

        <RevisionsList
          disabled={this.props.status.isReadOnly}
          form={this.props.form}
          getBaseUrl={this.props.getBaseUrl}
        />
      </div>
    );
  }
}

NewsletterMetadata.propTypes = {
  form: PropTypes.object.isRequired,
  getAuthorListAsyncForTypeahead: PropTypes.func.isRequired,
  status: PropTypes.object.isRequired,
  id: PropTypes.string.isRequired,
  getBaseUrl: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  form: state.editor.form,
  status: state.editor.status,
});

const mapDispatchToProps = {
  getAuthorListAsyncForTypeahead,
  getSubscriptionListAsyncForTypeahead,
  onChange,
  onChangeCheckbox,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NewsletterMetadata);
